import { LightLineSheetSet } from "@/features/line-sheet-sets/line-sheet-set.types";
import useFetcher from "@/utils/use-fetcher";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl, SWRObjectKey } from "@/features/ui/helpers/fetcher-helpers";

export interface UpdateLineSheetSetOrderRulesRequest {
  orderRules: string[];
}
export interface UpdateLineSheetSetOrderRulesResponse
  extends LightLineSheetSet {}

// 에이전시 또는 부티크 중 하나로 부른다. 부티크는 발행 뒤에도 오더룰을 고칠 수 있다.
export type UpdateLineSheetSetOrderRulesPathParameter =
  | { agencyId: number; lineSheetSetId: number }
  | { boutiqueId: number; lineSheetSetId: number };

export const UpdateLineSheetSetOrderRulesTemplateUrl = `/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/order-rules`;
export const UpdateBoutiqueLineSheetSetOrderRulesTemplateUrl = `/boutiques/:boutiqueId/line-sheet-sets/:lineSheetSetId/order-rules`;

export const UpdateLineSheetSetOrderRulesKey: YWRKey<UpdateLineSheetSetOrderRulesPathParameter> =
  {
    url: (parameter) => {
      return "boutiqueId" in parameter
        ? calcUrl(UpdateBoutiqueLineSheetSetOrderRulesTemplateUrl, parameter)
        : calcUrl(UpdateLineSheetSetOrderRulesTemplateUrl, parameter);
    },
    method: "put",
  };

export default function useUpdateLineSheetSetOrderRules() {
  const fetcher = useFetcher<
    UpdateLineSheetSetOrderRulesRequest,
    UpdateLineSheetSetOrderRulesResponse
  >();

  return useYWR(UpdateLineSheetSetOrderRulesKey, fetcher);
}
